import { render, staticRenderFns } from "./MisTareas.vue?vue&type=template&id=17afc6e8&"
import script from "./MisTareas.vue?vue&type=script&lang=js&"
export * from "./MisTareas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports